module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../~/dom-serializer/~/entities/maps/xml.json
// module id = 618
// module chunks = 1